if (document.readyState !== 'loading') 
{
    initN9ProductUpsells();
} 
else 
{
    document.addEventListener('DOMContentLoaded', function () 
    {
        initN9ProductUpsells();
    });
}

function arr2obj(arr) {let obj = {};arr.forEach((v) => {let key = v[0];let value = v[1];obj[key] = value;});return obj;}

function initN9ProductUpsells()
{
    var N9_atc_btn = document.querySelector("form[action*='/cart/add'] button[type='submit']");
    var ATCbtnClassesOrig = "button button--primary";
    var BtnClassPrimary = "button button--primary";
    var BtnClassSecondary = "button button--secondary";
    if(N9_atc_btn !== null)
    {
        ATCbtnClassesOrig = N9_atc_btn.className;ATCbtnClassesOrig = ATCbtnClassesOrig.replace('width', 'widthh');
        BtnClassPrimary = ATCbtnClassesOrig.replace('secondary', 'primary');
        BtnClassSecondary = ATCbtnClassesOrig.replace('primary', 'secondary');
    }
    document.querySelectorAll('.n9-fbt-btn-custom').forEach((button) => {button.className = button.className + ' ' + BtnClassPrimary;});
    document.querySelectorAll('.n9-fbt-btn-atc').forEach((button) => {button.className = button.className + ' ' + BtnClassPrimary;});
    if(n9_fbt_quickViewOption == 1){ document.querySelectorAll('.n9-quickview-btn-custom').forEach((button) => {button.className = button.className + ' ' + BtnClassPrimary;}); }

    if(upsellLayout == 1)
    {
        class N9_FBT extends HTMLElement 
        {
            moneyFormat(cents, format) 
            {
                if (typeof cents === 'string') 
                {
                    cents = cents.replace('.', '');
                }
                let value = '';
                const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
                var formatString = (format || window.money_format);
                if (!formatString) 
                {
                    formatString = n9MoneyFormat;
                }

                function defaultOption(opt, def) 
                {
                    return (typeof opt === 'undefined' ? def : opt);
                }

                function formatWithDelimiters(number, precision, thousands, decimal) 
                {
                    precision = defaultOption(precision, 2);
                    thousands = defaultOption(thousands, ',');
                    decimal = defaultOption(decimal, '.');
                    if (Number.isNaN(number) || number == null) {
                        return 0;
                    }
                    number = (number / 100.0).toFixed(precision);
                    const parts = number.split('.');
                    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                    cents = parts[1] ? (decimal + parts[1]) : '';
                    return dollars + cents;
                }
                switch (formatString.match(placeholderRegex)[1]) 
                {
                    case 'amount':
                        value = formatWithDelimiters(cents, 2);
                        break;
                    case 'amount_no_decimals':
                        value = formatWithDelimiters(cents, 0);
                        break;
                    case 'amount_with_comma_separator':
                        value = formatWithDelimiters(cents, 2, '.', ',');
                        break;
                    case 'amount_no_decimals_with_comma_separator':
                        value = formatWithDelimiters(cents, 0, '.', ',');
                        break;
                }
                return formatString.replace(placeholderRegex, value);
            }

            constructor() 
            {
                super();
                this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                {
                    select.addEventListener('change', () => {
                        this.onSelectVariant(select)
                    })
                });
                this.querySelectorAll('.n9-fbt-add-checkbox').forEach((checkbox) => 
                {
                    checkbox.addEventListener('change', () => {
                        this.onCheckVariantChange(checkbox)
                    })
                });
                this.querySelector('.n9-fbt-btn-atc').addEventListener('click', this.addSelectedVariantsToCart.bind(this));
                this.totalPriceChange();
            }
            onSelectVariant(select) 
            {
                const {image,comparePrice,price} = select.options[select.selectedIndex].dataset;
                const productItem = select.closest('.n9-fbt-product-item-layout2');
                const imgEl = productItem.querySelector('.n9-fbt-product-img');
                const comparePriceEl = productItem.querySelector('.n9-fbt-product-price-compare');
                const priceEl = productItem.querySelector('.n9-fbt-product-price-final');
                if (image) 
                {
                    imgEl.setAttribute('src', image);
                    imgEl.setAttribute('srcset', image);
                }
                if (comparePrice) 
                {
                    if (comparePrice <= price) 
                    {
                        comparePriceEl.style.display = 'none';
                    } 
                    else 
                    {
                        comparePriceEl.style.display = 'inline-block';
                    }
                    comparePriceEl.querySelector('s').innerHTML = this.moneyFormat(comparePrice);
                } 
                else 
                {
                    comparePriceEl.style.display = 'none';
                    comparePriceEl.querySelector('s').innerHTML = '';
                }
                priceEl.innerHTML = this.moneyFormat(price);
                this.totalPriceChange();
            }
            onCheckVariantChange(checkbox) 
            {
                const productItem = checkbox.closest('.n9-fbt-product-item-layout2');
                const imgEl = productItem.querySelector('.n9-fbt-product-img');
                if (checkbox.checked) 
                {
                    imgEl.style.opacity = '1';
                } 
                else 
                {
                    imgEl.style.opacity = '0.2';
                }
                this.totalPriceChange();
            }
            totalPriceChange() 
            {
                let totalPrice = 0;
                var allVariants = 0;
                var totalProds = 0;
                this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                {
                    if (select.closest('.n9-fbt-product-item-layout2').querySelector('.n9-fbt-add-checkbox').checked) 
                    {
                        totalPrice += Number(select.options[select.selectedIndex].dataset.price);
                        allVariants++;
                    }
                    totalProds++;
                });

                let discountedPrice = 0;
                let discount = 0;
                var newTotalPrice = totalPrice / 100.0;
                if (endDiscountType == 1) 
                {
                    discountedPrice = newTotalPrice - (endDiscountVal);
                    let shopMoneyFormat = n9MoneyFormat;
                    shopMoneyFormat = shopMoneyFormat;
                    shopMoneyFormat = shopMoneyFormat.charAt(0);
                    var discountInfo = (endDiscountVal);
                    discount = "-" + shopMoneyFormat + discountInfo.toFixed(2);
                } 
                else if (endDiscountType == 2) 
                {
                    discountedPrice = newTotalPrice - (newTotalPrice * endDiscountVal);
                    discount = endDiscountVal;
                    discount = "-" + ((discount * 100).toFixed()) + "%";
                } 

                
                if (allVariants > totalProds) 
                {
                    totalProds = allVariants;
                }

                if (totalProds == allVariants) 
                {
                    if (endDiscountType == 0) 
                    {
                        var offerPriceSoloText = n9_fbt_text_total_price;
                        if(allVariants == 1)
                        {
                            offerPriceSoloText = n9_fbt_text_soloPriceOne;
                        }

                        var message = '<p class="n9-fbt-total-price-line1" style="margin: 0; padding: 0; margin-top: 10px;"><span class="n9-fbt-total-price-text-normal" style="font-size: 16px;">'+offerPriceSoloText+'</span><b class="n9-fbt-total-price-text-price">'+this.moneyFormat(totalPrice)+'</b></p>';
                        this.querySelector('.n9-fbt-total-price-wrapper').innerHTML = message;

                        //this.querySelector('.n9-fbt-total-price').innerHTML = "<b>" + this.moneyFormat(totalPrice) + "</b>";
                        //this.querySelector('#endPriceText').innerHTML = n9_fbt_text_total_price;
                        //this.querySelector('#endPriceText').style.fontSize = "16px";
                    } 
                    else 
                    {
                        var discountOfferPriceText = n9_fbt_text_discounted_price;
                        if(availableProductsN9 == 1) 
                        {
                            discountOfferPriceText = n9_fbt_text_soloPrice;
                            this.querySelector('.n9-fbt-btn-atc').innerHTML = n9_fbt_text_soloButton;
                                this.querySelector('.n9-fbt-btn-atc').setAttribute("data-text-add-selected", n9_fbt_text_soloButton);
                        }
                        else
                        {
                            this.querySelector('.n9-fbt-btn-atc').innerHTML = n9_fbt_text_add_selected;
                            this.querySelector('.n9-fbt-btn-atc').setAttribute("data-text-add-selected", n9_fbt_text_add_selected);
                        }

                        var message1 = '<p class="n9-fbt-total-price-line1" style="margin: 0; padding: 0; margin-top: 10px; font-size: 14px;"><span class="n9-fbt-total-price-text-normal">'+n9_fbt_text_total_price2+'</span><b class="n9-fbt-total-price-text-price"><s>'+this.moneyFormat(totalPrice)+'</s></b></p>';
                        var message2 = '<p class="n9-fbt-total-price-line2" style="margin: 0; padding: 0;"><span class="n9-fbt-total-price-text-discount">'+discountOfferPriceText+'</span><b class="n9-fbt-total-price-text-price-discounted">'+this.moneyFormat(discountedPrice * 100.0)+'</b><small class="n9-fbt-total-price-text-discountInfo" style="display: initial;margin-left: 5px;">('+discount+')</small></p>';
                        this.querySelector('.n9-fbt-total-price-wrapper').innerHTML = message1 + message2;

                        //this.querySelector('.n9-fbt-total-price').innerHTML = "<s><small style='display: initial;'><b>" + this.moneyFormat(totalPrice) + "</b></small></s> <br>"+n9_fbt_text_discounted_price+"<b>" + this.moneyFormat(discountedPrice * 100.0) + "</b> <small style='display: initial;'>(" + discount + ")</small><br/>";
                        //this.querySelector('#endPriceText').innerHTML = n9_fbt_text_total_price2;
                        //this.querySelector('#endPriceText').style.fontSize = "14px";
                    }
                } 
                else 
                {
                    var message = '<p class="n9-fbt-total-price-line1" style="margin: 0; padding: 0; margin-top: 10px;"><span class="n9-fbt-total-price-text-normal" style="font-size: 16px;">'+n9_fbt_text_total_price+'</span><b class="n9-fbt-total-price-text-price">'+this.moneyFormat(totalPrice)+'</b></p>';
                    this.querySelector('.n9-fbt-total-price-wrapper').innerHTML = message;

                    //this.querySelector('.n9-fbt-total-price').innerHTML = "<b>" + this.moneyFormat(totalPrice) + "</b><br/>";
                    //this.querySelector('#endPriceText').innerHTML = n9_fbt_text_total_price;
                    //this.querySelector('#endPriceText').style.fontSize = "16px";
                } 
                

                if (totalPrice === 0) 
                {
                    this.querySelector('.n9-fbt-btn-atc').disabled = true;
                } 
                else 
                {
                    this.querySelector('.n9-fbt-btn-atc').disabled = false;
                }
                //this.querySelector('.n9-fbt-btn-atc').innerHTML = n9_fbt_text_add_selected;
            }
            async addSelectedVariantsToCart() 
            {
                const btn = this.querySelector('.n9-fbt-btn-atc');
                btn.innerHTML = `<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>`;
                btn.style.width = `${btn.clientWidth}px`;
                var buildUpdate = [];
                var buildAttribute = [];
            
                var allProducts = "";

                this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                {
                    if (select.closest('.n9-fbt-product-item-layout2').querySelector('.n9-fbt-add-checkbox').checked) 
                    {
                        var productId = select.getAttribute('data-product-id');
                        buildUpdate.push([Number(select.value), 1]);
                        buildAttribute.push(['n9_upsell--' + productId + '#'+n9CurrentProductId, select.value + ':all'+currentModeAttribute]);
                    }

                    if(endDiscountType > 0)
                    {
                        var currentProductId = select.getAttribute('data-product-id');
                        allProducts = allProducts + currentProductId + ",";
                    }
                });

                if(endDiscountType > 0)
                {
                    allProducts = allProducts.slice(0, -1); // removes last ,

                    //console.log(productsExists(n9_bundle_discounts, allProducts));
                    /*if(!productsExists(n9_bundle_discounts, allProducts))
                    {
                        if(endDiscountType == 1) // fixed
                        {
                            var addObj = {products: allProducts, discountValue: endDiscountVal, discountType: '0'};
                            n9_bundle_discounts.push(addObj);
                        }
                        else if(endDiscountType == 2) // %
                        {
                            var addObj = {products: allProducts, discountValue: endDiscountVal * 100, discountType: '1'};
                            n9_bundle_discounts.push(addObj);
                        }

                        buildAttribute.push(['n9_bundle_discounts', JSON.stringify(n9_bundle_discounts)]);
                    }*/

                    var discountTypeDiscounts = '1';
                    var discountValueDiscounts = endDiscountVal;
                    if(endDiscountType == 1) // fixed
                    {
                        discountTypeDiscounts = '0';
                        discountValueDiscounts = endDiscountVal;
                    }
                    else if(endDiscountType == 2) // %
                    {
                        discountTypeDiscounts = '1';
                        discountValueDiscounts = endDiscountVal * 100;
                    }

                    var addObj = {products: allProducts, discountValue: discountValueDiscounts, discountType: discountTypeDiscounts};
                    addN9BundleDiscountObject(addObj, n9_bundle_discounts);
                    buildAttribute.push(['n9_bundle_discounts', JSON.stringify(n9_bundle_discounts)]);
                }

                buildUpdate = arr2obj(buildUpdate);
                buildAttribute = arr2obj(buildAttribute);

                var headers = new Headers(
                {
                    'Content-Type': 'application/json'
                });
                var bodyRequest = JSON.stringify(
                {
                    updates: buildUpdate,
                    attributes: buildAttribute
                });
                var request = 
                {
                    method: 'POST',
                    headers: headers,
                    body: bodyRequest
                };
                await fetch('/cart/update.js', request).then(function () {});
                btn.innerHTML = n9_fbt_text_added;
                btn.disabled = true;
                if (n9_upsells_notify) 
                {
                    if (n9_upsells_mode_bundle == 0) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                    } 
                    else if (n9_upsells_mode_bundle == 1) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.href = '/cart';
                        }, 2000);
                    } 
                    else if (n9_upsells_mode_bundle == 2) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.reload();
                        }, 2000);
                    }
                    else if (n9_upsells_mode_bundle == 3) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.href = '/checkout';
                        }, 2000);
                    } 
                    else if (n9_upsells_mode_bundle == 4) 
                    {
                        //nothing for now
                    }
                    else if (n9_upsells_mode_bundle == 5) 
                    {
                        setTimeout(() => 
                        {
                            location.href = '/cart';
                        }, 1000);
                    }
                    else if (n9_upsells_mode_bundle == 6) 
                    {
                        setTimeout(() => 
                        {
                            location.reload();
                        }, 1000);
                    }
                    else if (n9_upsells_mode_bundle == 7) 
                    {
                        setTimeout(() => 
                        {
                            location.href = '/checkout';
                        }, 1000);
                    }
                }
            } 
        }

        if(document.querySelector('n9-fbt').hasChildNodes())
        { 
            customElements.define('n9-fbt', N9_FBT); 
        }
    }
    else if(upsellLayout == 2 || upsellLayout == 4 || upsellLayout == 5)
    {
        class N9_FBT extends HTMLElement 
        {
            moneyFormat(cents, format) 
            {
                if (typeof cents === 'string') 
                {
                    cents = cents.replace('.', '');
                }
                let value = '';
                const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
                var formatString = (format || window.money_format);
                if (!formatString) 
                {
                    formatString = n9MoneyFormat;
                }

                function defaultOption(opt, def) 
                {
                    return (typeof opt === 'undefined' ? def : opt);
                }

                function formatWithDelimiters(number, precision, thousands, decimal) 
                {
                    precision = defaultOption(precision, 2);
                    thousands = defaultOption(thousands, ',');
                    decimal = defaultOption(decimal, '.');
                    if (Number.isNaN(number) || number == null) {
                        return 0;
                    }
                    number = (number / 100.0).toFixed(precision);
                    const parts = number.split('.');
                    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                    cents = parts[1] ? (decimal + parts[1]) : '';
                    return dollars + cents;
                }
                switch (formatString.match(placeholderRegex)[1]) 
                {
                    case 'amount':
                        value = formatWithDelimiters(cents, 2);
                        break;
                    case 'amount_no_decimals':
                        value = formatWithDelimiters(cents, 0);
                        break;
                    case 'amount_with_comma_separator':
                        value = formatWithDelimiters(cents, 2, '.', ',');
                        break;
                    case 'amount_no_decimals_with_comma_separator':
                        value = formatWithDelimiters(cents, 0, '.', ',');
                        break;
                }
                return formatString.replace(placeholderRegex, value);
            }

            constructor() 
            {
                super();
                this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                {
                    select.addEventListener('change', () => 
                    {
                        this.onSelectVariant(select);
                    })
                });
                this.querySelectorAll('.n9-fbt-add-checkbox').forEach((checkbox) => 
                {
                    checkbox.addEventListener('change', () => 
                    {
                        this.onCheckVariantChange(checkbox);
                    })
                });
                this.querySelector('.n9-fbt-btn-atc').addEventListener('click', this.addSelectedVariantsToCart.bind(this));
                this.querySelectorAll('.n9-fbt-btn-custom').forEach((button) => 
                {
                    button.addEventListener('click', this.addCurrentVariantToCart.bind(this));
                    button.productId = button.getAttribute('data-product-id');
                });
                this.totalPriceChange();
            }
            onSelectVariant(select) 
            {
                const {image,comparePrice,price} = select.options[select.selectedIndex].dataset;
                const productItem = select.closest('.n9-fbt-product-item-layout3');
                const imgEl = productItem.querySelector('.n9-fbt-product-img');
                const comparePriceEl = productItem.querySelector('.n9-fbt-product-price-compare');
                const priceEl = productItem.querySelector('.n9-fbt-product-price-final');
                const btnEl = productItem.querySelector('.n9-fbt-btn-custom');
                if (image) 
                {
                    imgEl.setAttribute('src', image);
                    imgEl.setAttribute('srcset', image);
                }
                if (comparePrice) 
                {
                    if (comparePrice <= price) 
                    {
                        comparePriceEl.style.display = 'none';
                    } 
                    else 
                    {
                        comparePriceEl.style.display = 'inline-block';
                    }
                    comparePriceEl.querySelector('s').innerHTML = this.moneyFormat(comparePrice);
                } 
                else 
                {
                    comparePriceEl.style.display = 'none';
                    comparePriceEl.querySelector('s').innerHTML = '';
                }
                priceEl.innerHTML = this.moneyFormat(price);
                btnEl.disabled = false;
                btnEl.innerHTML = n9_fbt_text_add_to_cart;
                this.querySelector('.n9-fbt-btn-atc').innerHTML = n9_fbt_text_add_selected;
                this.totalPriceChange();
            }
            onCheckVariantChange(checkbox) 
            {
                const productItem = checkbox.closest('.n9-fbt-product-item-layout3');
                const imgEl = productItem.querySelector('.n9-fbt-product-img');
                if (checkbox.checked) 
                {
                    imgEl.style.opacity = '1';
                } 
                else 
                {
                    imgEl.style.opacity = '0.2';
                }
                this.totalPriceChange();
            }
            totalPriceChange() 
            {
                let totalPrice = 0;
                var allVariants = 0;
                this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                {
                    if (select.closest('.n9-fbt-product-item-layout3').querySelector('.n9-fbt-add-checkbox').checked) 
                    {
                        totalPrice += Number(select.options[select.selectedIndex].dataset.price);
                    }
                    allVariants++;
                });
                let discountedPrice = 0;
                let discount = 0;
                var newTotalPrice = totalPrice / 100.0;
                if (endDiscountType == 1) 
                {
                    discountedPrice = newTotalPrice - (endDiscountVal);
                    let shopMoneyFormat = n9MoneyFormat;
                    shopMoneyFormat = shopMoneyFormat;
                    shopMoneyFormat = shopMoneyFormat.charAt(0);
                    var discountInfo = (endDiscountVal);
                    discount = "-" + shopMoneyFormat + discountInfo.toFixed(2);
                } 
                else if (endDiscountType == 2) 
                {
                    discountedPrice = newTotalPrice - (newTotalPrice * endDiscountVal);
                    discount = endDiscountVal;
                    discount = "-" + ((discount * 100).toFixed()) + "%";
                } 

                if (endDiscountType == 0) 
                {
                    var offerPriceSoloText = n9_fbt_text_total_price;
                    if(allVariants == 1)
                    {
                        offerPriceSoloText = n9_fbt_text_soloPriceOne;
                        var imgBlocks = this.querySelectorAll(".n9-product-img-block-layout3");
                        imgBlocks.forEach((el) => 
                        {
                            el.style = "transform: translateY(10%);";
                        });
                    }

                    var message = '<p class="n9-fbt-total-price-line1" style="margin: 0; padding: 0; margin-top: 10px;"><span class="n9-fbt-total-price-text-normal" style="font-size: 16px;">'+offerPriceSoloText+'</span><b class="n9-fbt-total-price-text-price">'+this.moneyFormat(totalPrice)+'</b></p>';
                    this.querySelector('.n9-fbt-total-price-wrapper').innerHTML = message;
                            
                    //this.querySelector('.n9-fbt-total-price').innerHTML = "<b>" + this.moneyFormat(totalPrice) + "</b>";
                    //this.querySelector('#endPriceText').innerHTML = n9_fbt_text_total_price;
                    //this.querySelector('#endPriceText').style.fontSize = "16px";
                }
                else 
                {
                    var discountOfferPriceText = n9_fbt_text_discounted_price;
                    if(availableProductsN9 == 1)
                    {
                        discountOfferPriceText = n9_fbt_text_soloPrice;
                        this.querySelector('.n9-fbt-btn-atc').innerHTML = n9_fbt_text_soloButton;
                        this.querySelector('.n9-fbt-btn-atc').setAttribute("data-text-add-selected", n9_fbt_text_soloButton);

                        var imgBlocks = this.querySelectorAll(".n9-product-img-block-layout3");
                        imgBlocks.forEach((el) => 
                        {
                            el.style = "transform: translateY(10%);";
                        });
                    }
                    else
                    {
                        this.querySelector('.n9-fbt-btn-atc').innerHTML = n9_fbt_text_add_selected;
                        this.querySelector('.n9-fbt-btn-atc').setAttribute("data-text-add-selected", n9_fbt_text_add_selected);
                    }

                    var message1 = '<p class="n9-fbt-total-price-line1" style="margin: 0; padding: 0; margin-top: 10px; font-size: 14px;"><span class="n9-fbt-total-price-text-normal">'+n9_fbt_text_total_price2+'</span><b class="n9-fbt-total-price-text-price"><s>'+this.moneyFormat(totalPrice)+'</s></b></p>';
                    var message2 = '<p class="n9-fbt-total-price-line2" style="margin: 0; padding: 0;"><span class="n9-fbt-total-price-text-discount">'+discountOfferPriceText+'</span><b class="n9-fbt-total-price-text-price-discounted">'+this.moneyFormat(discountedPrice * 100.0)+'</b><small class="n9-fbt-total-price-text-discountInfo" style="display: initial;margin-left: 5px;">('+discount+')</small></p>';
                    this.querySelector('.n9-fbt-total-price-wrapper').innerHTML = message1 + message2;

                    //this.querySelector('.n9-fbt-total-price').innerHTML = "<s><small style='display: initial;'><b>" + this.moneyFormat(totalPrice) + "</b></small></s> <br>"+n9_fbt_text_discounted_price+"<b>" + this.moneyFormat(discountedPrice * 100.0) + "</b> <small style='display: initial;'>(" + discount + ")</small><br/>";
                    //this.querySelector('#endPriceText').innerHTML = n9_fbt_text_total_price2;
                    //this.querySelector('#endPriceText').style.fontSize = "14px";
                }
                
                if (totalPrice === 0) 
                {
                    this.querySelector('.n9-fbt-btn-atc').disabled = true;
                } 
                else 
                {
                    this.querySelector('.n9-fbt-btn-atc').disabled = false;
                }
            }
            async addCurrentVariantToCart(evt) 
            {
                var productId = evt.currentTarget.productId;
                const btn = this.querySelector('#n9_product_btn_' + productId);
                btn.innerHTML = `<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>`;
                var buildUpdate = [];
                var buildAttribute = [];

                var allProducts = "";

                this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                {
                    if(endDiscountType > 0)
                    {
                        var currentProductId = select.getAttribute('data-product-id');
                        allProducts = allProducts + currentProductId + ",";
                    }
                });

                if(endDiscountType > 0)
                {
                    allProducts = allProducts.slice(0, -1); // removes last ,

                    //console.log(productsExists(n9_bundle_discounts, allProducts));
                    /*if(!productsExists(n9_bundle_discounts, allProducts))
                    {
                        if(endDiscountType == 1) // fixed
                        {
                            var addObj = {products: allProducts, discountValue: endDiscountVal, discountType: '0'};
                            n9_bundle_discounts.push(addObj);
                        }
                        else if(endDiscountType == 2) // %
                        {
                            var addObj = {products: allProducts, discountValue: endDiscountVal * 100, discountType: '1'};
                            n9_bundle_discounts.push(addObj);
                        }

                        buildAttribute.push(['n9_bundle_discounts', JSON.stringify(n9_bundle_discounts)]);
                    }*/
                    var discountTypeDiscounts = '1';
                    var discountValueDiscounts = endDiscountVal;
                    if(endDiscountType == 1) // fixed
                    {
                        discountTypeDiscounts = '0';
                        discountValueDiscounts = endDiscountVal;
                    }
                    else if(endDiscountType == 2) // %
                    {
                        discountTypeDiscounts = '1';
                        discountValueDiscounts = endDiscountVal * 100;
                    }

                    var addObj = {products: allProducts, discountValue: discountValueDiscounts, discountType: discountTypeDiscounts};
                    addN9BundleDiscountObject(addObj, n9_bundle_discounts);
                    buildAttribute.push(['n9_bundle_discounts', JSON.stringify(n9_bundle_discounts)]);
                }

                this.querySelectorAll('#n9_variant_select_' + productId).forEach((select) => 
                {
                    buildUpdate.push([Number(select.value), 1]);
                    buildAttribute.push(['n9_upsell--' + productId + '#'+n9CurrentProductId, select.value + ':btn'+currentModeAttribute]);
                });
                
                buildUpdate = arr2obj(buildUpdate);
                buildAttribute = arr2obj(buildAttribute);
                var headers = new Headers(
                {
                    'Content-Type': 'application/json'
                });
                var bodyRequest = JSON.stringify(
                {
                    updates: buildUpdate,
                    attributes: buildAttribute
                });
                var request = 
                {
                    method: 'POST',
                    headers: headers,
                    body: bodyRequest
                };
                await fetch('/cart/update.js', request).then(function () {});
                btn.innerHTML = n9_fbt_text_added;
                btn.disabled = true;
                
                if (n9_upsells_notify)
                {
                    if (n9_upsells_mode_single == 0) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                    } 
                    else if (n9_upsells_mode_single == 1) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.href = '/cart';
                        }, 2000);
                    } 
                    else if (n9_upsells_mode_single == 2) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.reload();
                        }, 2000);
                    }
                    else if (n9_upsells_mode_single == 3) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.href = '/checkout';
                        }, 2000);
                    } 
                    else if (n9_upsells_mode_single == 4) 
                    {
                        //nothing for now
                    }
                    else if (n9_upsells_mode_single == 5) 
                    {
                        setTimeout(() => 
                        {
                            location.href = '/cart';
                        }, 1000);
                    }
                    else if (n9_upsells_mode_single == 6) 
                    {
                        setTimeout(() => 
                        {
                            location.reload();
                        }, 1000);
                    }
                    else if (n9_upsells_mode_single == 7) 
                    {
                        setTimeout(() => 
                        {
                            location.href = '/checkout';
                        }, 1000);
                    }
                }
            }
            async addSelectedVariantsToCart() 
            {
                const btn = this.querySelector('.n9-fbt-btn-atc');
                btn.innerHTML = `<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>`;
                btn.style.width = `${btn.clientWidth}px`;
                var buildUpdate = [];
                var buildAttribute = [];

                var allProducts = "";

                this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                {
                    if (select.closest('.n9-fbt-product-item-layout3').querySelector('.n9-fbt-add-checkbox').checked) 
                    {
                        var productId = select.getAttribute('data-product-id');
                        buildUpdate.push([Number(select.value), 1]);
                        buildAttribute.push(['n9_upsell--' + productId + '#'+n9CurrentProductId, select.value + ':all'+currentModeAttribute]);
                    }

                    if(endDiscountType > 0)
                    {
                        var currentProductId = select.getAttribute('data-product-id');
                        allProducts = allProducts + currentProductId + ",";
                    }
                });

                if(endDiscountType > 0)
                {
                    allProducts = allProducts.slice(0, -1); // removes last ,

                    //console.log(productsExists(n9_bundle_discounts, allProducts));
                    /*if(!productsExists(n9_bundle_discounts, allProducts))
                    {
                        if(endDiscountType == 1) // fixed
                        {
                            var addObj = {products: allProducts, discountValue: endDiscountVal, discountType: '0'};
                            n9_bundle_discounts.push(addObj);
                        }
                        else if(endDiscountType == 2) // %
                        {
                            var addObj = {products: allProducts, discountValue: endDiscountVal * 100, discountType: '1'};
                            n9_bundle_discounts.push(addObj);
                        }

                        buildAttribute.push(['n9_bundle_discounts', JSON.stringify(n9_bundle_discounts)]);
                    }*/
                    var discountTypeDiscounts = '1';
                    var discountValueDiscounts = endDiscountVal;
                    if(endDiscountType == 1) // fixed
                    {
                        discountTypeDiscounts = '0';
                        discountValueDiscounts = endDiscountVal;
                    }
                    else if(endDiscountType == 2) // %
                    {
                        discountTypeDiscounts = '1';
                        discountValueDiscounts = endDiscountVal * 100;
                    }

                    var addObj = {products: allProducts, discountValue: discountValueDiscounts, discountType: discountTypeDiscounts};
                    addN9BundleDiscountObject(addObj, n9_bundle_discounts);
                    buildAttribute.push(['n9_bundle_discounts', JSON.stringify(n9_bundle_discounts)]);
                }

                buildUpdate = arr2obj(buildUpdate);
                buildAttribute = arr2obj(buildAttribute);
                var headers = new Headers(
                {
                    'Content-Type': 'application/json'
                });
                var bodyRequest = JSON.stringify(
                {
                    updates: buildUpdate,
                    attributes: buildAttribute
                });
                var request = 
                {
                    method: 'POST',
                    headers: headers,
                    body: bodyRequest
                };
                await fetch('/cart/update.js', request).then(function () {});
                btn.innerHTML = n9_fbt_text_added;
                btn.disabled = true;
                if (n9_upsells_notify) 
                {
                    if (n9_upsells_mode_bundle == 0) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                    } 
                    else if (n9_upsells_mode_bundle == 1) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.href = '/cart';
                        }, 2000);
                    } 
                    else if (n9_upsells_mode_bundle == 2) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.reload();
                        }, 2000);
                    }
                    else if (n9_upsells_mode_bundle == 3) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.href = '/checkout';
                        }, 2000);
                    } 
                    else if (n9_upsells_mode_bundle == 4) 
                    {
                        //nothing for now
                    }
                    else if (n9_upsells_mode_bundle == 5) 
                    {
                        setTimeout(() => 
                        {
                            location.href = '/cart';
                        }, 1000);
                    }
                    else if (n9_upsells_mode_bundle == 6) 
                    {
                        setTimeout(() => 
                        {
                            location.reload();
                        }, 1000);
                    }
                    else if (n9_upsells_mode_bundle == 7) 
                    {
                        setTimeout(() => 
                        {
                            location.href = '/checkout';
                        }, 1000);
                    }
                }
            }
        }

        if(document.querySelector('n9-fbt').hasChildNodes())
        { 
            customElements.define('n9-fbt', N9_FBT); 
        }
    }
    else if(upsellLayout == 3 || upsellLayout == 6)
    {
        class N9_FBT extends HTMLElement 
        {
            moneyFormat(cents, format) 
            {
                if (typeof cents === 'string') 
                {
                    cents = cents.replace('.', '');
                }
                let value = '';
                const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
                var formatString = (format || window.money_format);
                if (!formatString) 
                {
                    formatString = n9MoneyFormat;
                }

                function defaultOption(opt, def) 
                {
                    return (typeof opt === 'undefined' ? def : opt);
                }

                function formatWithDelimiters(number, precision, thousands, decimal) 
                {
                    precision = defaultOption(precision, 2);
                    thousands = defaultOption(thousands, ',');
                    decimal = defaultOption(decimal, '.');
                    if (Number.isNaN(number) || number == null) {
                        return 0;
                    }
                    number = (number / 100.0).toFixed(precision);
                    const parts = number.split('.');
                    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                    cents = parts[1] ? (decimal + parts[1]) : '';
                    return dollars + cents;
                }
                switch (formatString.match(placeholderRegex)[1]) 
                {
                    case 'amount':
                        value = formatWithDelimiters(cents, 2);
                        break;
                    case 'amount_no_decimals':
                        value = formatWithDelimiters(cents, 0);
                        break;
                    case 'amount_with_comma_separator':
                        value = formatWithDelimiters(cents, 2, '.', ',');
                        break;
                    case 'amount_no_decimals_with_comma_separator':
                        value = formatWithDelimiters(cents, 0, '.', ',');
                        break;
                }
                return formatString.replace(placeholderRegex, value);
            }

            constructor() 
            {
                super();
                this.querySelectorAll('.n9-fbt-variant-select').forEach((select) => 
                {
                    select.addEventListener('change', () => 
                    {
                        this.onSelectVariant(select);
                    })
                });
                this.querySelectorAll('.n9-fbt-btn-custom').forEach((button) => 
                {
                    button.addEventListener('click', this.addCurrentVariantToCart.bind(this));
                    button.productId = button.getAttribute('data-product-id');
                });
            }
            onSelectVariant(select) 
            {
                const {image,comparePrice,price} = select.options[select.selectedIndex].dataset;
                const productItem = select.closest('.n9-fbt-product-item-layout4');
                const imgEl = productItem.querySelector('.n9-fbt-product-img');
                const btnEl = productItem.querySelector('.n9-fbt-btn-custom');
                const priceEl = productItem.querySelector('.n9-fbt-product-price-final');
                const comparePriceDiv = productItem.querySelector('.n9-fbt-product-price');
                const comparePriceEl = comparePriceDiv.querySelector('.n9-fbt-product-price-compare');
                if (image) 
                {
                    imgEl.setAttribute('src', image);
                    imgEl.setAttribute('srcset', image);
                }
                if (comparePrice) 
                {
                    if (comparePrice <= price) 
                    {
                        comparePriceEl.style.display = 'none';
                    } 
                    else 
                    {
                        comparePriceEl.style.display = 'inline-block';
                    }
                    comparePriceEl.querySelector('s').innerHTML = this.moneyFormat(comparePrice);
                } 
                else 
                {
                    comparePriceEl.style.display = 'none';
                    comparePriceEl.querySelector('s').innerHTML = '';
                }
                priceEl.innerHTML = this.moneyFormat(price);
                btnEl.disabled = false;
                btnEl.innerHTML = n9_fbt_text_add_to_cart;
            }
            async addCurrentVariantToCart(evt) 
            {
                var productId = evt.currentTarget.productId;
                const btn = this.querySelector('#n9_product_btn_' + productId);
                btn.innerHTML = `<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>`;
                var buildUpdate = [];
                var buildAttribute = [];
                this.querySelectorAll('#n9_variant_select_' + productId).forEach((select) => 
                {
                    buildUpdate.push([Number(select.value), 1]);
                    buildAttribute.push(['n9_upsell--' + productId + '#'+productId, select.value + ':btn'+currentModeAttribute]);
                });
                buildUpdate = arr2obj(buildUpdate);
                buildAttribute = arr2obj(buildAttribute);
                var headers = new Headers(
                {
                    'Content-Type': 'application/json'
                });
                var bodyRequest = JSON.stringify(
                {
                    updates: buildUpdate,
                    attributes: buildAttribute
                });
                var request = 
                {
                    method: 'POST',
                    headers: headers,
                    body: bodyRequest
                };
                await fetch('/cart/update.js', request).then(function () {});
                btn.innerHTML = n9_fbt_text_added;
                btn.disabled = true;
                if (n9_upsells_notify) 
                {
                    if (n9_upsells_mode_single == 0) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_bundle, NotifyOptionsUpsells);
                    }
                    else if (n9_upsells_mode_single == 1) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.href = '/cart';
                        }, 2000);
                    } 
                    else if (n9_upsells_mode_single == 2) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.reload();
                        }, 2000);
                    }
                    else if (n9_upsells_mode_single == 3) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.href = '/checkout';
                        }, 2000);
                    } 
                    else if (n9_upsells_mode_single == 4) 
                    {
                        //nothing for now
                    }
                    else if (n9_upsells_mode_single == 5) 
                    {
                        setTimeout(() => 
                        {
                            location.href = '/cart';
                        }, 1000);
                    }
                    else if (n9_upsells_mode_single == 6) 
                    {
                        setTimeout(() => 
                        {
                            location.reload();
                        }, 1000);
                    }
                    else if (n9_upsells_mode_single == 7) 
                    {
                        setTimeout(() => 
                        {
                            location.href = '/checkout';
                        }, 1000);
                    }
                }
            }
        }

        if(document.querySelector('n9-fbt').hasChildNodes())
        { 
            customElements.define('n9-fbt', N9_FBT); 

            setTimeout(() => 
            {
                if(upsellLayout == 6) Splide.defaults = {type: 'loop',perPage: 2,perMove: 2,pagination: true,flickMaxPages: 1,autoplay: true,pauseOnHover: true,pauseOnFocus: true,arrows: false,clones: 0, focus: 0, omitEnd : true};
                else Splide.defaults = {type: 'loop',perPage: 1,pagination: true,flickMaxPages: 1,autoplay: true,pauseOnHover: true,pauseOnFocus: true,arrows: false,clones: 0};
                var splide = new Splide('.splide');splide.mount();
            }, 1000);
        }
    }



    if(n9_fbt_quickViewOption == 1)
    {
        class N9_QuickView extends HTMLElement 
        {
            constructor() 
            {
                super();
                this.querySelectorAll('.n9-quickview-variant-select').forEach((select) => 
                {
                    select.addEventListener('change', () => 
                    {
                        this.onSelectVariant(select);
                    })
                });
                this.querySelectorAll('.n9-quickview-btn-custom').forEach((button) => 
                {
                    button.addEventListener('click', this.addCurrentVariantToCart.bind(this));
                    button.productId = button.getAttribute('data-product-id');
                });
            }
            onSelectVariant(select) 
            {
                const {image,comparePrice,price} = select.options[select.selectedIndex].dataset;
                var select_product = select.getAttribute('data-product-id');
                const footerBox = select.closest('.n9Upsells-Product-FooterBox');
                const productBlock = document.querySelector("#n9-quickview-product-block_" + select_product);
                const imgEl = productBlock.firstElementChild;
                const btnEl = footerBox.querySelector('.n9-quickview-btn-custom');
                const comparePriceEl = footerBox.querySelector('.n9-quickview-product-price-compare');
                const priceEl = footerBox.querySelector('.n9-quickview-product-price-final');
                if (image) 
                {
                    imgEl.setAttribute('src', image);
                    imgEl.setAttribute('srcset', image);
                }
                if (comparePrice) 
                {
                    if (comparePrice <= price) 
                    {
                        comparePriceEl.style.display = 'none';
                    } 
                    else 
                    {
                        comparePriceEl.style.display = 'inline-block';
                    }
                    comparePriceEl.querySelector('s').innerHTML = this.moneyFormat(comparePrice);
                } 
                else 
                {
                    comparePriceEl.style.display = 'none';
                    comparePriceEl.querySelector('s').innerHTML = '';
                }
                priceEl.innerHTML = this.moneyFormat(price);
                btnEl.disabled = false;
                btnEl.innerHTML = n9_fbt_text_add_to_cart;
            }
            async addCurrentVariantToCart(evt) 
            {
                var productId = evt.currentTarget.productId;
                const btn = this.querySelector('#n9_quickview_product_btn_' + productId);
                btn.innerHTML = `<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>`;
                var buildUpdate = [];
                var buildAttribute = [];
                this.querySelectorAll('#n9_quickview_variant_select_' + productId).forEach((select) => {
                    buildUpdate.push([Number(select.value), 1]);
                    buildAttribute.push(['n9_upsell--' + productId + '#'+n9CurrentProductId, select.value + ':quickview'+currentModeAttribute]);
                });
                buildUpdate = arr2obj(buildUpdate);
                buildAttribute = arr2obj(buildAttribute);
                var headers = new Headers({
                    'Content-Type': 'application/json'
                });
                var bodyRequest = JSON.stringify({
                    updates: buildUpdate,
                    attributes: buildAttribute
                });
                var request = {
                    method: 'POST',
                    headers: headers,
                    body: bodyRequest
                };
                await fetch('/cart/update.js', request).then(function () {});
                btn.innerHTML = n9_fbt_text_added;
                btn.disabled = true;
                if (n9_upsells_notify) 
                {
                    if (n9_upsells_mode_single == 0)
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                    } 
                    else if (n9_upsells_mode_single == 1) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.href = '/cart';
                        }, 2000);
                    } 
                    else if (n9_upsells_mode_single == 2) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.reload();
                        }, 2000);
                    }
                    else if (n9_upsells_mode_single == 3) 
                    {
                        Notiflix.Notify.success(n9_fbt_text_notify_single, NotifyOptionsUpsells);
                        setTimeout(() => 
                        {
                            location.href = '/checkout';
                        }, 2000);
                    } 
                    else if (n9_upsells_mode_single == 4) 
                    {
                        //nothing for now
                    }
                    else if (n9_upsells_mode_single == 5) 
                    {
                        setTimeout(() => 
                        {
                            location.href = '/cart';
                        }, 1000);
                    }
                    else if (n9_upsells_mode_single == 6) 
                    {
                        setTimeout(() => 
                        {
                            location.reload();
                        }, 1000);
                    }
                    else if (n9_upsells_mode_single == 7) 
                    {
                        setTimeout(() => 
                        {
                            location.href = '/checkout';
                        }, 1000);
                    }
                }
            }
            moneyFormat(cents, format) 
            {
                if (typeof cents === 'string') 
                {
                    cents = cents.replace('.', '');
                }
                let value = '';
                const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
                //console.log(placeholderRegex);
                var formatString = (format || window.money_format);
                if (!formatString) {
                    formatString = n9MoneyFormat;
                }

                function defaultOption(opt, def) {
                    return (typeof opt === 'undefined' ? def : opt);
                }

                function formatWithDelimiters(number, precision, thousands, decimal) {
                    precision = defaultOption(precision, 2);
                    thousands = defaultOption(thousands, ',');
                    decimal = defaultOption(decimal, '.');
                    if (Number.isNaN(number) || number == null) {
                        return 0;
                    }
                    number = (number / 100.0).toFixed(precision);
                    const parts = number.split('.');
                    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                    cents = parts[1] ? (decimal + parts[1]) : '';
                    return dollars + cents;
                }
                switch (formatString.match(placeholderRegex)[1]) {
                    case 'amount':
                        value = formatWithDelimiters(cents, 2);
                        break;
                    case 'amount_no_decimals':
                        value = formatWithDelimiters(cents, 0);
                        break;
                    case 'amount_with_comma_separator':
                        value = formatWithDelimiters(cents, 2, '.', ',');
                        break;
                    case 'amount_no_decimals_with_comma_separator':
                        value = formatWithDelimiters(cents, 0, '.', ',');
                        break;
                }
                return formatString.replace(placeholderRegex, value);
            }
        }
        customElements.define('n9-quickview', N9_QuickView);
        document.body.insertAdjacentElement("afterbegin", document.querySelector("n9-quickview")); 
    }
}

function n9_OpenProductQuickView(id, handle) 
{
    if(n9_fbt_quickViewOption == 1)
    {
        if(document.querySelector('#N9QuickViewProduct_' + id) !== null)
        {
            document.querySelector('#N9QuickViewProduct_' + id).style.display = '';
            setTimeout(() => 
            {
                document.querySelector('#N9QuickViewProduct_' + id).style.opacity = '1';
                document.querySelector('#N9QuickViewProduct_' + id + '_2').style.display = '';
            }, 100);
        }
    }
    else if(n9_fbt_quickViewOption == 2)
    {
        window.open('/products/'+handle, '_blank').focus();
    }
}

function n9_CloseProductQuickView(id) 
{
    document.querySelector('#N9QuickViewProduct_' + id + '_2').classList.add('n9-animation-zoom-out');
    setTimeout(() => 
    {
        document.querySelector('#N9QuickViewProduct_' + id).style.opacity = '0';
    }, 200);
    setTimeout(() => 
    {
        document.querySelector('#N9QuickViewProduct_' + id + '_2').style.display = 'none';
        document.querySelector('#N9QuickViewProduct_' + id + '_2').classList.remove('n9-animation-zoom-out');
    }, 500);
    setTimeout(() => 
    {
        document.querySelector('#N9QuickViewProduct_' + id).style.display = 'none';
    }, 700);
} 